
import {Vue, Component, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";

@Component({})
export default class AcceptCguDialog extends Vue {

    @Prop({default: false})
    public invitationBy: string;

    @Getter private currentUser: any;
    @Getter private isMobile: boolean;

    private acceptCguModale: boolean = true;
    private confirmAcceptCgu: boolean = false;

    private acceptCgu(): Promise<any> {
        return this.$store.dispatch("users/updateUserCguAcceptedAt", {
            id: this.currentUser.id,
            invitationBy: this.invitationBy,
        }).then(() => {
            this.acceptCguModale = false;
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n.t("alerts.cgu.cguAccepted"),
            });
        });
    }
}
